import { useQuery } from '@tanstack/react-query';
import { preloadCharacterSideData } from '@/pages/ranking/characterProfileSide';

const STALE_MS = 60_000;

/** Stats/buffs — columna derecha, independiente del perfil (como loadCharacterStats en CI4). */
export function useCharacterSideData(charId: number) {
  return useQuery({
    queryKey: ['character', charId, 'side'],
    queryFn: () => preloadCharacterSideData(charId),
    staleTime: STALE_MS,
    retry: 1,
  });
}
